import SiteManagerView from "@/Site/SiteManagerView";
import DeviceDetailsView from "./DeviceDetailsView";
import TemsWebEvents from "@/TemsWebEvents";
import { SiteState, SensorOperationState } from "@/TemsManagerWebEnums";
import { ViewModelUserLevel } from 'Tems/Security/TemsPolicy';
import { CustomButton } from "@/LayoutManagerView";
import Localization from "@/Localization";
import { SensorConfigViewModel, SensorOperationViewModel, ElementTypeViewModel } from "@/TemsManagerWebInterface";
import ManagerView from "@/ManagerView";

export default class SensorOperationsView {

    private siteManagerView: SiteManagerView;
    private deviceDetailView: DeviceDetailsView;
    private waitingForSensorDiscoveryFinish: boolean = false;
    private waitingForSensorUpdateFinish: boolean = false;
    private configurationSetupActive: boolean;
    private sensorConfigsModal: JQuery;
    private sensorConfigsParentDomElement: JQuery;
    private sensorOperationsParentDomElement: JQuery;

    constructor(siteManagerView: SiteManagerView, sensorConfigsParentModal: JQuery, sensorOperationsParentDomElement: JQuery) {
        this.siteManagerView = siteManagerView;
        this.deviceDetailView = new DeviceDetailsView(siteManagerView);
        this.sensorConfigsModal = sensorConfigsParentModal;
        this.sensorConfigsParentDomElement = sensorConfigsParentModal.find(".modal-body").first();
        this.sensorOperationsParentDomElement = sensorOperationsParentDomElement;
        TemsWebEvents.subscribeEvent(TemsWebEvents.SiteStateChanged, (evt, newSiteState) => { this.handleSiteStateChange(newSiteState); });
    }

    private handleSiteStateChange(siteState: SiteState) {
        this.configurationSetupActive = false;
        var finishSensorOperation = () => {
            this.cancelSensorOperations(() => {
                this.siteManagerView.hideAcknowledgementModal();
                this.showSensorConfigDiscovery();
            });
        };

        var buttonConfirmFinished = CustomButton.Create(
            Localization.resourceStrings.SensorOperationsManagerView_HeaderButtonConfirmFinish,
            finishSensorOperation,
            true);
        switch (siteState) {
            case SiteState.SensorDiscoveryCompleted:
                if (this.waitingForSensorDiscoveryFinish) {
                    this.waitingForSensorDiscoveryFinish = false;
                    this.siteManagerView.hideProcessingModal();
                    finishSensorOperation();
                }
                break;
            case SiteState.SensorDiscoveryFailure:
                if (this.waitingForSensorDiscoveryFinish) {
                    this.waitingForSensorDiscoveryFinish = false;
                    this.siteManagerView.hideProcessingModal();
                    this.siteManagerView.showAcknowledgementModal(
                        Localization.resourceStrings.SensorOperationsManagerView_MessageInfoDiscoveryFailed,
                        Localization.resourceStrings.SensorOperationsManagerView_TitleInfoDiscoveryFailed,
                        buttonConfirmFinished,
                        CustomButton.Create(),
                        CustomButton.Create()
                    );
                }
                break;
            case SiteState.SensorUpdateCompleted:
                if (this.waitingForSensorUpdateFinish) {
                    this.waitingForSensorUpdateFinish = false;
                    this.siteManagerView.hideProcessingModal();
                    finishSensorOperation();
                }
                break;
            case SiteState.SensorUpdateFailure:
                if (this.waitingForSensorUpdateFinish) {
                    this.waitingForSensorUpdateFinish = false;
                    this.siteManagerView.hideProcessingModal();
                    this.siteManagerView.showAcknowledgementModal(
                        Localization.resourceStrings.SensorOperationsManagerView_MessageInfoUpdateFailed,
                        Localization.resourceStrings.SensorOperationsManagerView_TitleInfoUpdateFailed,
                        buttonConfirmFinished,
                        CustomButton.Create(),
                        CustomButton.Create()
                    );
                }
                break;
            case SiteState.ConfigurationSetupActive:
                this.configurationSetupActive = true;
                break;
        }
    }

    private cancelSensorOperations(doneHandler = (data?: any) => { }) {
        $.ajax({
            url: "/api/SiteEdit/CancelSensorOperations",
            type: "POST"
        }).done(
            doneHandler
            ).fail((jqXHR, status, error) => {
                this.siteManagerView.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, jqXHR.responseJSON.Message, Localization.resourceStrings.SiteView_ModalAlertErrorMessage);
            });
    }

    private changeSensorIpConfiguration(sensorConfig: SensorConfigViewModel) {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            if (this.configurationSetupActive) {
                this.siteManagerView.showProcessingModal([], Localization.resourceStrings.SensorOperationsManagerView_TitleInfoUpdateRunning);

                $.ajax({
                    url: "/api/SiteEdit/UpdateSensorConfig",
                    type: "POST",
                    data: JSON.stringify(sensorConfig),
                    contentType: "application/json",
                    traditional: true,
                }).done(() => {
                    this.waitingForSensorUpdateFinish = true;
                }).fail((jqXHR, state, error) => {
                    this.siteManagerView.hideProcessingModal();
                    this.siteManagerView.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, jqXHR.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                });
            }
        });
    }

    private createDomElementFromSensorConfig(config: SensorConfigViewModel, deviceId: string): JQuery {
        const assignmentState: string = config.AssignedDeviceId ?
            config.AssignedDeviceId == deviceId ?
                "success" :
                "warning" :
            "info";
        const editableOptions: XEditableOptions = { mode: 'inline' };
        const divSensorConfig = $("<div>", { 'data-sensorConfigId': config.Id, class: `alert alert-${assignmentState}` });
        const tHeadSensorName = $("<th>", { class: "col-md-4", html: config.Name });
        const spanAssignedState = $("<div>", { html: "", style: "display:none;" });
        let hasConfigChanges = false;

        const buttonUnassignDevice =
            $("<button>", {
                class: "btn btn-default",
                html: `<span class="glyphicon glyphicon-scissors"></span> ${Localization.resourceStrings.SensorOperationsManagerView_HeaderButtonUnassign}`,
                title: `${Localization.resourceStrings.SensorOperationsManagerView_DescriptionButtonUnassign}`
            }).click((event) => {
                this.assignSensorConfigToDevice(null, config.AssignedDeviceId);
            });

        const buttonAssignDevice =
            $("<button>", {
                class: "btn btn-default roundCornerRight",
                html: `<span class="glyphicon glyphicon-transfer"></span> ${Localization.resourceStrings.SensorOperationsManagerView_HeaderButtonAssignSensor}`,
                title: `${Localization.resourceStrings.SensorOperationsManagerView_DescriptionButtonAssignSensor}`
            }).click((event) => {
                this.assignSensorConfigToDevice(config.Id, deviceId);
            });

        const buttonConfigureDevice =
            $("<button>", {
                class: "btn btn-default submitSensorConfigurationChanges",
                html: `<span class="glyphicon glyphicon-floppy-disk"></span> ${Localization.resourceStrings.SensorOperationsManagerView_HeaderButtonConfigureSensor}`,
                title: `${Localization.resourceStrings.SensorOperationsManagerView_DescriptionButtonConfigureSensor}`,
                style: "display:none;"
            }).click((event) => {
                var parameterNames = $.map(config.Parameters, (parameter) => {
                    return parameter.ParameterName;
                });

                if (!config.AssignedDeviceId) {
                    tbody.find(".editSensorConfigField").each((idx, elem) => {
                        var index = $.inArray($(elem).data("paramname"), parameterNames);

                        config.Parameters[index].CurrentValue = $(elem).html();
                    });

                    this.changeSensorIpConfiguration(config);
                    handleButtonVisibility();
                }
            });

        const buttonResetToDiscoveryValues =
            $("<button>", {
                class: "btn btn-default",
                html: `<span class="glyphicon glyphicon-erase"></span> ${Localization.resourceStrings.SensorOperationsManagerView_HeaderButtonReset}`,
                title: `${Localization.resourceStrings.SensorOperationsManagerView_DescriptionButtonReset}`,
                style: "display:none;"
            }).click((event) => {
                var paramNames = $.map(config.Parameters, (parameter) => {
                    return parameter.ParameterName;
                });

                if (!config.AssignedDeviceId) {
                    tbody.find(".editSensorConfigField").each((idx, elem) => {
                        var index = $.inArray($(elem).data("paramname"), paramNames);

                        config.Parameters[index].CurrentValue = config.Parameters[index].DiscoveryValue;
                    });

                    this.changeSensorIpConfiguration(config);
                    handleButtonVisibility();
                }

                handleButtonVisibility();
            });

        const handleButtonVisibility = () => {
            setTimeout(() => {
                var domChanges = false;
                var configChanges = false;
                var parameterNames = $.map(config.Parameters, (parameter) => {
                    return parameter.ParameterName;
                });

                tbody.find(".editSensorConfigField").each((idx, elem) => {
                    var index = $.inArray($(elem).data("paramname"), parameterNames);

                    if (config.Parameters[index].DiscoveryValue !== $(elem).html()) {
                        domChanges = true;
                    }
                });

                $.each(config.Parameters, (idx, param) => {
                    if (param.DiscoveryValue && param.DiscoveryValue !== param.CurrentValue) {
                        configChanges = true;
                        return false;
                    }
                });

                if (config.AssignedDeviceId) {
                    const isAssignedToDevice = config.AssignedDeviceId === deviceId;
                    buttonAssignDevice.toggle(!isAssignedToDevice && !configChanges && !domChanges);
                    buttonUnassignDevice.show();
                    buttonUnassignDevice.addClass("roundCornerLeft");
                    buttonUnassignDevice.toggleClass("roundCornerRight", domChanges || isAssignedToDevice);
                    spanAssignedState.show().html(
                        Localization.resourceStrings.SensorOperationsManagerView_SensorAssignedToOtherDevice
                            .replace("{0}", `'${this.siteManagerView.getPathById(config.AssignedDeviceId)}'`)
                    );
                    buttonResetToDiscoveryValues.hide();
                    buttonConfigureDevice.hide();
                    enableEditable(false);
                } else {
                    buttonAssignDevice.toggle(!configChanges && !domChanges);
                    buttonAssignDevice.toggleClass("roundCornerLeft", !domChanges);
                    buttonAssignDevice.toggleClass("roundCornerRight", !domChanges && !configChanges);
                    buttonUnassignDevice.hide();
                    spanAssignedState.hide();
                    buttonResetToDiscoveryValues.toggle(domChanges);
                    buttonConfigureDevice.toggle(configChanges || domChanges);
                    buttonConfigureDevice.toggleClass("roundCornerLeft", !domChanges);
                    enableEditable(true);
                }
            }, 0);
        }

        const enableEditable = (enabled: boolean) => {
            divSensorConfig.find(".editSensorConfigField").each((index, element) => {
                $(element).editable(enabled ? "enable" : "disable");
            });
        }

        const handleConfigurationChange = (evt, param) => {
            if ($(evt.target).data("discovery") !== param.newValue) {
                handleButtonVisibility();
                $(evt.target).addClass("editable-unsaved");
            } else {
                setTimeout(() => { $(evt.target).removeClass("editable-unsaved"); }, 10);
                var showConfigureButton = false;

                divSensorConfig.find(".editSensorConfigField").each((index, element) => {
                    if (element !== evt.target) {
                        if ($(element).data("discovery") !== $(element).html()) {
                            showConfigureButton = true;
                            $(element).addClass("editable-unsaved");
                        } else {
                            $(element).removeClass("editable-unsaved");
                        }
                    }
                });

                handleButtonVisibility();
            }
        }

        const table = $("<table>", { class: "table table-condensed" });

        const thead = $("<thead>")
            .append($("<tr>")
                .append(tHeadSensorName)
                .append($("<th>", { colspan: 2, class: "col-md-8", style: "text-align:right;" })
                    .append(spanAssignedState)
                    .append($("<div>", { class: "btn-group" })
                        .append(buttonResetToDiscoveryValues)
                        .append(buttonUnassignDevice)
                        .append(buttonAssignDevice)
                        .append(buttonConfigureDevice)
                    )
                )
            );

        const tbody = $("<tbody>")

        this.prependSensorTypeIcon(tHeadSensorName, config.TypeId);

        if (config.Parameters) {
            $.each(config.Parameters, (index, param) => {
                const row = $("<tr>")
                    .append($("<th>", { class: "col-md-4", html: param.DisplayName }));

                if (param.DiscoveryValue) {
                    const editableElement = $("<span>", {
                        class: "editSensorConfigField",
                        'data-paramName': param.ParameterName,
                        'data-discovery': param.DiscoveryValue,
                        html: param.CurrentValue
                    })
                        .toggleClass("editable-unsaved", param.DiscoveryValue !== param.CurrentValue)
                        .on("save", handleConfigurationChange);

                    hasConfigChanges = hasConfigChanges || param.DiscoveryValue !== param.CurrentValue;

                    editableElement.editable(editableOptions);

                    row.append($("<td>", { class: "col-md-4" }).append(editableElement))
                        .append($("<td>", { class: "col-md-4 discoveryValueColumn", html: `[${param.DiscoveryValue}]` }));
                } else {
                    row.append($("<td>", { colspan: 2, class: "col-md-8", html: param.CurrentValue }));
                }

                tbody.append(row);
            });
        }

        divSensorConfig.append(table);
        table
            .append(thead)
            .append(tbody);

        handleButtonVisibility();

        return divSensorConfig;
    }

    private assignSensorConfigToDevice(sensorConfigId: string, deviceId: string) {
        $.post(
            `/api/SiteEdit/UpdateDeviceSensorAssignment?deviceId=${deviceId}&sensorConfigId=${sensorConfigId}`,
            (data, textStatus, jqXHR) => {
                this.siteManagerView.forceSiteModelUpdate();
                this.showSensorConfigDiscovery();
                TemsWebEvents.publishEvent(TemsWebEvents.DeviceSensorAssignmentChanged, [deviceId]);
            }
        ).fail(err => {
            this.siteManagerView.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, err.responseJSON.Message);
        });
    }

    private prependSensorTypeIcon(domElement: JQuery, sensorTypeId: string) {
        $.ajax({
            url: `/api/SiteEdit/GetElementTypes?type=Sensor&typeId=${sensorTypeId}`
        }).done((sensorTypes: ElementTypeViewModel[]) => {
            sensorTypes.forEach((value, index, array) => {
                if (value.Id === sensorTypeId) {
                    domElement.prepend($("<img>", { class: "sensor-image", src: `/api/Info/GetIcon/${value.IconId}` }));
                    return false;
                }
            });
        });
    }

    public startSensorDiscovery() {
        var buttonCancel = CustomButton.Create(
            Localization.resourceStrings.SiteView_ButtonCancel,
            () => {
                this.cancelSensorOperations();
                this.siteManagerView.hideProcessingModal();
            },
            true
        );

        $.post("/api/SiteEdit/StartSensorDiscovery", () => {
            this.siteManagerView.showProcessingModal([], Localization.resourceStrings.SensorOperationsManagerView_TitleInfoDiscoveryRunning, "", buttonCancel);
            this.waitingForSensorDiscoveryFinish = true;
        }).fail(err => {
            this.siteManagerView.showAlertMessage(Localization.resourceStrings.LayoutView_ErrorTitleGeneral, err.responseJSON.Message);
        });
    }

    public createSensorOperationInfo(sensorOperations: SensorOperationViewModel[]) {
        $.each(sensorOperations, (index, sensorOperation) => {
            var dismissButton = $("<button>", { type: "button", class: "close", 'aria-label': "Close" })
                .append($("<span>", { 'aria-hidden': true, html: "&times;" }))
                .click((event) => {
                    this.sensorOperationsParentDomElement.children(`div[data-id='${sensorOperation.SensorConfigId}']`).hide();
                    this.sensorOperationsParentDomElement.children(`div[data-id='${sensorOperation.SensorConfigId}']`).addClass("dissmissed");
                });
            var contextualClass =
                sensorOperation.State === SensorOperationState.Failed ?
                    "alert-danger" :
                    sensorOperation.State === SensorOperationState.Unknown ?
                        "alert-warning" :
                        "alert-success";
            var table = $("<table>", { class: "table table-condensed" });
            var tbody = $("<tbody>");
            var div = this.sensorOperationsParentDomElement.children(`div[data-id='${sensorOperation.SensorConfigId}']`);

            table.append($("<thead>")
                .append($("<tr>")
                    .append($("<th>", { colspan: 2, html: sensorOperation.Name }).append(dismissButton))
                )
            );

            tbody.append($("<tr>")
                .append($("<th>", { html: sensorOperation.OperationId }))
                .append($("<td>", { html: SensorOperationState[sensorOperation.State] }))
            );

            if (sensorOperation.ResultMessage !== "") {
                tbody.append($("<tr>")
                    .append($("<td>", { colspan: 2, class: "borderless", html: sensorOperation.ResultMessage }))
                );
            }

            table.append(tbody);

            if (div.length === 0) {
                div = $("<div>", { class: `alert-dissmissable alert ${contextualClass}`, 'data-id': sensorOperation.SensorConfigId });
                this.sensorOperationsParentDomElement.append(div);
            }

            div.html("");
            div.append(table);

            if (div.hasClass("dissmissed")) {
                div.hide();
            } else {
                div.show();
            }
        });

        var domElements = this.sensorOperationsParentDomElement.children("div.alert");
        if (domElements.length > sensorOperations.length) {
            var dataIds = $.map(sensorOperations, (s) => { return s.Name; });
            $.each(domElements, (index, elem) => {
                if ($.inArray($(elem).data("id"), dataIds) === -1) {
                    $(elem).remove();
                }
            });
        }
    }

    public showSensorConfigDiscovery(deviceId?: string, supportedSensorTypeIds?: string[]) {
        if (deviceId === undefined) {
            deviceId = this.sensorConfigsParentDomElement.data("deviceId");
        } else {
            this.sensorConfigsParentDomElement.data("deviceId", deviceId);
        }

        if (supportedSensorTypeIds === undefined) {
            supportedSensorTypeIds = this.sensorConfigsParentDomElement.data("sensorTypeIds");
        } else {
            this.sensorConfigsParentDomElement.data("sensorTypeIds", supportedSensorTypeIds);
        }

        this.sensorConfigsParentDomElement.html("");
        this.sensorConfigsModal.modal(ManagerView.MODAL_SHOW_BACKDROP);

        if (this.configurationSetupActive) {
            $.ajax({
                url: "/api/Info/GetSensorConfigs"
            }).done((SensorConfigs: SensorConfigViewModel[]) => {
                if (SensorConfigs) {
                    let assignedToDevice: JQuery;
                    let unassigned: JQuery[] = [];
                    let assignedToOther: JQuery[] = [];

                    $.each(SensorConfigs, (index, config) => {
                        if ($.inArray(config.TypeId, supportedSensorTypeIds) >= 0) {
                            if (config.AssignedDeviceId == deviceId) {
                                assignedToDevice = this.createDomElementFromSensorConfig(config, deviceId);
                            } else if (config.AssignedDeviceId) {
                                assignedToOther.push(this.createDomElementFromSensorConfig(config, deviceId))
                            } else {
                                unassigned.push(this.createDomElementFromSensorConfig(config, deviceId));
                            }
                        }
                    });

                    this.sensorConfigsParentDomElement.append(assignedToDevice);
                    $.each(unassigned, (index) => {
                        this.sensorConfigsParentDomElement.append(unassigned[index]);
                    });
                    $.each(assignedToOther, (index) => {
                        this.sensorConfigsParentDomElement.append(assignedToOther[index]);
                    });


                    if (SensorConfigs.length === 0) {
                        this.sensorConfigsParentDomElement.append($("<div>", {
                            class: "alert alert-info",
                            html: `${Localization.resourceStrings.SensorOperationsManagerView_MessageNoSensorConfigsInfo}`
                        }));
                    }
                }
            });
        } else {
            this.sensorConfigsParentDomElement.append($("<div>", {
                class: "alert alert-info",
                html: `${Localization.resourceStrings.SensorOperationsManagerView_MessageLoadSensorConfigsInfo}`
            }));
            this.siteManagerView.forceSiteModelUpdate();
            setTimeout(() => { this.showSensorConfigDiscovery(); }, 500);
        }
    }

    public closeSensorConfigDiscovery() {
        this.sensorConfigsModal.modal("hide");
    }

    public changeDisplayTitle(title: string) {
        this.sensorConfigsModal.find(".modal-title").html(title);
    }
}
